import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import AppRemixIcon from '../icon/AppRemixIcon'
import colors from '../../../constants/colors'
import Translator from '../helpers/Translator'


export default function AppDeleteModal(props) {
  const {
    show,
    size = 'md',
    title = 'Confirmar eliminar',
    text,
    onClose,
    onConfirm,
    sensitive = false,
    sensitiveWord = 'delete me'
  } = props
  const handleClose = () => onClose(false)
  const handleConfirm = () => onConfirm()
  const [removeButtonDisabled, setRemoveButtonDisabled] = useState(sensitive)

  const handleSensitiveCase = (value) => {
    if (value === sensitiveWord) setRemoveButtonDisabled(false)
    else setRemoveButtonDisabled(true)
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} size={size}>
        <Modal.Header closeButton>
          <Modal.Title>
            <AppRemixIcon
              icon='delete-bin'
              color={colors.danger}
              className='mr-2'
            />
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {text || <Translator file="module-legalCompliance" name="remove.selected.element" />}
            <br />
            <br />
            {sensitive && (
              <>
                <p>
                  Por seguridad, para eliminar este elemento, debe escribir{' '}
                  <b>'{sensitiveWord}'</b> en el siguiente campo.
                </p>
                <div className='row'>
                  <div className='col-sm-12'>
                    <input
                      onChange={(e) => handleSensitiveCase(e.target.value)}
                      className='form-control mb-2'
                    />
                  </div>
                </div>
              </>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='default' onClick={handleClose}>
            {<Translator file="user" name="user.cancel" />}
          </Button>
          <Button
            variant='danger'
            onClick={handleConfirm}
            disabled={removeButtonDisabled}
          >
            {<Translator file="user" name="user.delete" />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
